import { motion } from "framer-motion";
import { chessManifesto } from "@/data/clubs";
import { Reveal } from "@/components/Reveal";
import { useScrollTo } from "@/lib/scroll";

const ease = [0.22, 1, 0.36, 1];

export const ChessManifesto = () => {
  const { title, author, role, chapters } = chessManifesto;
  const scrollTo = useScrollTo();
  return (
    <section id="chess" className="relative bg-ink text-paper overflow-hidden">
      <div className="absolute -top-24 left-0 font-head font-black text-[30vw] leading-none text-white/[0.035] pointer-events-none select-none">
        ♟
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-10 py-24 md:py-36 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="font-head font-semibold text-white/50 tracking-wide mb-6">מניפסט • חוג השחמט</p>
              <h2 className="font-serif-he font-black text-5xl md:text-7xl leading-[0.95]">{title}</h2>
              <div className="mt-8 h-px w-24 bg-accent" />
              <p className="mt-8 font-serif-he text-2xl">{author}</p>
              <p className="mt-2 text-white/55 leading-relaxed max-w-sm">{role}</p>
              <button
                onClick={() => scrollTo("register")}
                className="inline-flex mt-10 font-head font-semibold bg-accent text-white px-7 py-3.5 rounded-full hover:bg-accent-600 transition-colors"
                data-testid="chess-register-link"
              >
                להרשמה לחוג
              </button>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:pr-10">
            <div className="space-y-12">
              {chapters.map((c, i) => (
                <motion.div
                  key={c.n}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.8, delay: i * 0.05, ease }}
                  className="border-t border-white/15 pt-6 flex gap-6"
                >
                  <span className="font-head font-black text-2xl text-accent shrink-0">{c.n}</span>
                  <div>
                    <h3 className="font-serif-he text-2xl md:text-3xl mb-3">{c.heading}</h3>
                    <p className="text-white/70 text-lg leading-relaxed">{c.text}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
